<template>
	<div class="customer_detail_default" ref="customer_detail_default">
		<el-tabs v-model="activetab" @tab-click="ChangeTabs" type="card">
			<el-tab-pane :label="tab.name" v-for="(tab, tabindex) in tabs" :key="tabindex">
				<span slot="label" v-if="tabindex == '0'">{{ tab.name }}</span>
				<span slot="label" v-if="tabindex == '1'">
					{{ tab.name }}
					<el-badge is-dot class="item" v-if="isupdate"></el-badge>
				</span>
				<div v-if="activetab == '0'" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }"><customerinfo ref="customerinfo" :id="id" ></customerinfo></div>
				<div v-if="activetab == '1'" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }"><crmfollowlist ref="crmfollowlist" :id="id"></crmfollowlist></div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import customerinfo from '@/components/crm/addcustomer_default.vue';
import crmfollowlist from '@/components/crm/crmfollowlist.vue';
export default {
	components: {
		customerinfo,
		crmfollowlist
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		},
		id: {
			type: String,
			default: ''
		},
		updatetime:{//客户信息更新时间
			type: String,
			default: ''
		},
		handle:{
			type: String,
			default: '0'
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 170,
			divclass: 'customer_detail_default',
			activetab: '0',
			tabs: [{ name: '客户信息' }, { name: '跟进记录' }],
			isupdate: false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/crm/customer_detail.scss');
		});
	},
	methods: {
		init() {
			var that=this;
			if(this.handle=='1'){
				this.ChangeTabs({index:'1'});
			}else{
				if (that.$refs.customerinfo != undefined) {
					that.$refs.customerinfo[0].init({id:this.id,isdetail:true});
				}
			}
			if(this.updatetime.indexOf('1900-')>-1){
				this.isupdate=true;
			}
		},
		//切换选项卡
		ChangeTabs(tab) {
			var that = this;
			this.activetab = tab.index;
			if (this.activetab =="0") {
				this.$nextTick(function(){
				if (that.$refs.customerinfo != undefined) {
					that.$refs.customerinfo[0].init({id:this.id,isdetail:true});
				}
				});
			}
			if (this.activetab == "1") {
				this.$nextTick(function(){
					if (that.$refs.crmfollowlist != undefined) {
						that.$refs.crmfollowlist[1].init();
					}
				});
			}
		}
	}
};
</script>

<style></style>
